var React = require('react');

function WeatherCloud (props) {
    return React.createElement("svg",props,React.createElement("path",{"className":"path","d":"M51.67 54.73H19.95c-7.35 0-13.33-5.98-13.33-13.33s5.98-13.33 13.33-13.33h7.9c.76-7.06 6.75-12.57 14-12.57 7.49 0 13.63 5.88 14.06 13.26C61.26 30.56 65 35.64 65 41.4c0 7.35-5.98 13.33-13.33 13.33zM19.95 32.07c-5.14 0-9.33 4.18-9.33 9.33s4.18 9.33 9.33 9.33h31.72c5.14 0 9.33-4.18 9.33-9.33 0-4.42-3.14-8.26-7.46-9.14l-1.6-.33v-2.35c0-5.56-4.52-10.08-10.08-10.08-5.56 0-10.08 4.52-10.08 10.08v2.49H19.95z"}));
}

WeatherCloud.defaultProps = {"viewBox":"0 0 72 72"};

module.exports = WeatherCloud;

WeatherCloud.default = WeatherCloud;
